<template>
    <el-drawer
        title="发送通知"
        :visible="visible"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @open="show"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
            >
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="24" :xl="24">
                        <el-form-item label="默认通知内容:">
                            <div v-html="defaultContent"></div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="24" :xl="24">
                        <el-form-item prop="content" label="自定义通知内容:">
                            <el-input
                                type="textarea"
                                placeholder="请填写自定义通知内容"
                                v-model="formData.content"
                                maxlength="200"
                                show-word-limit
                                size="medium"
                            ></el-input>
                            <small class="color-danger MT10">如果不填写自定义通知内容，则向用户如实展示【默认通知内容】<br>如果填写了自定义通知内容，则仅向用户展示自定义通知内容</small>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="24" :xl="24">
                        <el-form-item prop="isRefundTicket" label="退票政策:">
                            <el-radio v-model="formData.isRefundTicket" :label="1">支持退票</el-radio>
                            <el-radio v-model="formData.isRefundTicket" :label="2">不支持退票</el-radio>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="40" v-if="formData.isRefundTicket === 1">
                    <el-col :xs="24" :sm="24" :xl="24">
                        <el-form-item prop="refundEndTime" label="退票截止时间:">
                            <el-date-picker
                                v-model="formData.refundEndTime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm"
                                format="yyyy-MM-dd HH:mm"
                                :picker-options="pickerOptions"
                                size="medium">
                            </el-date-picker>
                            <small class="MT10 lineH25">
								1、系统默认以主办填写的【申请退票截止时间】为准，演出开演时间仅供参考
                                <div class="color-danger">2、当前场次开演时间：{{ showStartTime }}</div>
                                3、截止时间不能大于开演时间<br/>
                                4、原则上不建议开演前1小时内不再支持退票，但可根据实际情况灵活确定截止时间<br/>
                            </small>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    props: {
        id: {
            type: [Number, String],
            default: () => null
        },
        visible: {
            type: Boolean,
            default: false
        },
        detail: {
            type: Object,
            default: null
        }
    },
    data(){
        const self = this;
        return{
            pickerOptions:{
                disabledDate(time) {
                    return self.showStartTime ? time.getTime() > new Date(self.showStartTime).getTime() : true;
                },
            },
            btnLoading: false,
            showStartTime: '',
            formData: {
                content: '',
                isRefundTicket: 1,
                refundEndTime: '',
                ids: []
            },
            rules: {
                // content: [{ required: true, message: "请选择变动内容" }],
                isRefundTicket: [{ required: true, message: "请选择退票政策" }],
                refundEndTime: [{ required: true, message: "请设置退票截止时间" }],
            },
            defaultContent: ''
        }
    },
    methods:{
        close() {
            this.$emit('update:visible', false);
        },
        show() {
			console.log(this.detail)
            this.formData.activityId = this.id;
            this.defaultContent = this.detail.content.replaceAll(';','<br>');
            this.formData.ids = this.detail.ids;
            this.showStartTime = this.detail.showStartTime;
            this.formData.refundEndTime = this.detail.canRefundTime ? this.detail.canRefundTime : this.detail.recommendRefundEndTime;
        },
        async submitForm(){
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const response = await this.$request({
                        url: '/activityUpdateRecord/send',
                        data: {
                            ...this.formData,
                            content: this.formData.content || this.detail.content
                        }
                    })
                    const {msg, state} = response.data;
                    this.btnLoading = false;
                    if (state != 1) return this.$message.error(msg);
                    this.$message.success('发送成功');
                    this.formData = {
                        content: '',
                        isRefundTicket: 1,
                        refundEndTime: '',
                        ids: []
                    };
                    this.showStartTime = '';
                    this.defaultContent = '';
                    this.$emit('update:visible', false);
                    this.$emit('onRefresh', true);
                }
            });
            
        }
    }
}
</script>
<style lang="scss" scoped>
.lineH25{
	line-height:25px
}
</style>